/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RateInfoRespVo
 */
export interface RateInfoRespVo {
    /**
     * 主键 ID
     * @type {number}
     * @memberof RateInfoRespVo
     */
    id?: number;
    /**
     * 国家id
     * @type {number}
     * @memberof RateInfoRespVo
     */
    nationId?: number;
    /**
     * 国家名称(韩文)
     * @type {string}
     * @memberof RateInfoRespVo
     */
    nationName?: string;
    /**
     * 国家名称(中文)
     * @type {string}
     * @memberof RateInfoRespVo
     */
    nationNameCn?: string;
    /**
     * 国家名称(英文)
     * @type {string}
     * @memberof RateInfoRespVo
     */
    nationNameEn?: string;
    /**
     * 汇率有效开始日期
     * @type {string}
     * @memberof RateInfoRespVo
     */
    startDate?: string;
    /**
     * 汇率有效结束日期
     * @type {string}
     * @memberof RateInfoRespVo
     */
    endDate?: string;
    /**
     * 关税厅公示汇率
     * @type {number}
     * @memberof RateInfoRespVo
     */
    exchangeRate?: number;
    /**
     * 适用汇率
     * @type {number}
     * @memberof RateInfoRespVo
     */
    applyExchangeRate?: number;
    /**
     * 兑换汇率
     * @type {number}
     * @memberof RateInfoRespVo
     */
    conversionExchangeRate?: number;
    /**
     * 是否可用 0 不可用，1 可用
     * @type {number}
     * @memberof RateInfoRespVo
     */
    enable?: number;
    /**
     * 创建时间
     * @type {string}
     * @memberof RateInfoRespVo
     */
    createTime?: string;
    /**
     * 修改时间
     * @type {string}
     * @memberof RateInfoRespVo
     */
    updateTime?: string;
}

/**
 * Check if a given object implements the RateInfoRespVo interface.
 */
export function instanceOfRateInfoRespVo(value: object): value is RateInfoRespVo {
    return true;
}

export function RateInfoRespVoFromJSON(json: any): RateInfoRespVo {
    return RateInfoRespVoFromJSONTyped(json, false);
}

export function RateInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RateInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'nationId': json['nationId'] == null ? undefined : json['nationId'],
        'nationName': json['nationName'] == null ? undefined : json['nationName'],
        'nationNameCn': json['nationNameCn'] == null ? undefined : json['nationNameCn'],
        'nationNameEn': json['nationNameEn'] == null ? undefined : json['nationNameEn'],
        'startDate': json['startDate'] == null ? undefined : json['startDate'],
        'endDate': json['endDate'] == null ? undefined : json['endDate'],
        'exchangeRate': json['exchangeRate'] == null ? undefined : json['exchangeRate'],
        'applyExchangeRate': json['applyExchangeRate'] == null ? undefined : json['applyExchangeRate'],
        'conversionExchangeRate': json['conversionExchangeRate'] == null ? undefined : json['conversionExchangeRate'],
        'enable': json['enable'] == null ? undefined : json['enable'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'updateTime': json['updateTime'] == null ? undefined : json['updateTime'],
    };
}

export function RateInfoRespVoToJSON(json: any): RateInfoRespVo {
    return RateInfoRespVoToJSONTyped(json, false);
}

export function RateInfoRespVoToJSONTyped(value?: RateInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'nationId': value['nationId'],
        'nationName': value['nationName'],
        'nationNameCn': value['nationNameCn'],
        'nationNameEn': value['nationNameEn'],
        'startDate': value['startDate'],
        'endDate': value['endDate'],
        'exchangeRate': value['exchangeRate'],
        'applyExchangeRate': value['applyExchangeRate'],
        'conversionExchangeRate': value['conversionExchangeRate'],
        'enable': value['enable'],
        'createTime': value['createTime'],
        'updateTime': value['updateTime'],
    };
}

